export const navbar = {
  Search: 'Rechercher',
  SearchPlaceholder: 'Que voulez-vous écouter ?',
  Home: 'Accueil',
  'Your Library': 'Votre Bibliothèque',
  'Collapse your library': 'Réduire votre bibliothèque',
  'Expand your library': 'Développer votre bibliothèque',
  Language: 'Langue',
  'Contact me': 'Contactez-moi',
  'Choose a language': 'Choisissez une langue',
};
